import { FunctionComponent } from "react";
import { useHistory } from "react-router";
import { Route } from "react-router-dom";
import { useStoreContext } from "../../contexts/StoreProvider";
import NoAccess from "../../pages/NoAccess";

const AuthenticatedRoute = ({ component, ...rest }) => {
  const {
    state: { user },
  } = useStoreContext();
  const history = useHistory();
  const Component: FunctionComponent = component;

  if (user && user.role.type === "administrator" && !history.location.pathname.includes("/admin/")) {
    history.push(`/admin${history.location.pathname}`);
    // to eliminate the console error when already authenticate and admin user to be redirect
    return null;
  }

  return (
    <Route {...rest} render={() => (user ? <Component /> : <NoAccess />)} />
  );
};

export default AuthenticatedRoute;
